"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M10.969 13.031v-8.25a1.03 1.03 0 1 1 2.062 0v8.25a1.03 1.03 0 1 1-2.062 0m-.206 5.982A1.237 1.237 0 1 1 12 20.25h-.002a1.234 1.234 0 0 1-1.234-1.234z"
}), 'PriorityHigh');
//# sourceMappingURL=index.js.map